import { useEffect } from "react";

export default function SEO({ title, description, canonical, image, jsonLd }) {
  useEffect(() => {
    if (title) document.title = title;
    const setMeta = (attr, key, val) => {
      if (!val) return;
      let el = document.head.querySelector(`meta[${attr}="${key}"]`);
      if (!el) { el = document.createElement("meta"); el.setAttribute(attr, key); document.head.appendChild(el); }
      el.setAttribute("content", val);
    };
    setMeta("name", "description", description);
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:type", "website");
    if (image) setMeta("property", "og:image", image);
    setMeta("name", "twitter:card", "summary_large_image");

    let link = document.head.querySelector('link[rel="canonical"]');
    const url = canonical || window.location.href;
    if (!link) { link = document.createElement("link"); link.rel = "canonical"; document.head.appendChild(link); }
    link.href = url;

    let script = document.getElementById("page-jsonld");
    if (jsonLd) {
      if (!script) { script = document.createElement("script"); script.type = "application/ld+json"; script.id = "page-jsonld"; document.head.appendChild(script); }
      script.textContent = JSON.stringify(jsonLd);
    } else if (script) {
      script.remove();
    }
  }, [title, description, canonical, image, jsonLd]);
  return null;
}
